<template>
  <div>
    <KTCodePreview v-bind:title="printTitle">
      <template v-slot:toolbar>
        <b-button
          variant="primary"
          size="sm"
          class="font-weight-bolder"
          @click="onClickToPrint(printMode)"
        >
          <i style="font-size: 1rem" class="fas fa-print"></i>In phiếu
        </b-button>
      </template>
      <template v-slot:preview>
        <hr
          class="hr-text"
          data-content="Khổ giấy A4- A5"
          style="font-weight: 600"
        />
        <div id="A4" v-if="!isLoading">
          <PrintTransaction
            :printData="mainModel"
            :transactionType="transactionType"
          />
        </div>
        <br />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { handleError } from '@/utils/common';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import PrintTransaction from '@/view/components/transaction/PrintTransaction.vue';
import { TIME_TRIGGER } from '@/utils/constants';
import saveData from '@/utils/saveDataToLocal';
import { convertNumberToText, upperCaseFirstLetter } from '@/utils/common';
import { TRANSACTION_TYPE } from '@/utils/enum';

export default {
  components: {
    KTCodePreview,
    PrintTransaction,
  },
  data() {
    return {
      mainModel: {
        transaction: null,
      },
      printMode: 'A4',
      transactionType: null, // 'IN' or 'OUT'
      isLoading: false,
      printTitle: 'In phiếu',
    };
  },
  created() {
    let defaultPrintMode = saveData.getData('defaultPrintMode');
    if (!defaultPrintMode) {
      defaultPrintMode = 'A4';
      saveData.saveData('defaultPrintMode', this.printMode);
    }
    this.printMode = defaultPrintMode;
    const transactionId = this.$route.query.id;
    this.getTransactionById(transactionId);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'In phiếu thu chi' }]);
  },
  methods: {
    getTransactionById(id) {
      this.isLoading = true;
      ApiService.get(`v1/transactions/print/${id}`).then((response) => {
        const data = response.data.data;
        const amountText = convertNumberToText(data.amount);
        data.amountText = upperCaseFirstLetter(amountText);
        this.mainModel.transaction = data;

        const transactionIN = [
          TRANSACTION_TYPE.CashIn,
          TRANSACTION_TYPE.BankIn,
        ];
        const transactionOUT = [
          TRANSACTION_TYPE.CashOut,
          TRANSACTION_TYPE.BankOut,
        ];

        if (transactionIN.includes(data.type)) {
          this.printTitle = 'In phiếu thu';
          this.transactionType = 'IN';
        } else if (transactionOUT.includes(data.type)) {
          this.printTitle = 'In phiếu chi';
          this.transactionType = 'OUT';
        }
      }).catch((error) => {
        handleError(error);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    printData(mode = 'A4', stylePrint) {
      const prtHtml = document.getElementById(mode).innerHTML;
      let stylesHtml = '';
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        '',
        '',
        'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0',
      );
      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
          ${stylePrint}
        </head>
        <body`);
      WinPrint.document.write(`${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function () {
        WinPrint.print();
      }, TIME_TRIGGER);
    },
    getStylePrint() {
      return `<style>
                .supplier-company-name {font-size: 15px !important; color: black; font-weight: 600;}
                .custom-lable-text {font-size: 13px !important; font-weight: 500 !important; color: black;}
                .font-size-name{ font-size: 20px !important; color: black;}
                .font-size-price{ font-size: 30px !important; font-weight: bold !important;}
                .item-print {
                    width: 100% !important;
                    margin-left: 0px !important;
                  }
                @media print {
                  .signature-section .row {
                    display: flex !important;
                    flex-wrap: nowrap !important;
                  }
                  .signature-section .col {
                    flex: 0 0 33.33% !important;
                    width: 33.33% !important;
                    max-width: 33.33% !important;
                  }
                }
              </style>`;
    },
    onClickToPrint(mode) {
      this.printMode = mode;
      const stylePrint = this.getStylePrint();
      this.printData(mode, stylePrint);
    },
  },
};
</script>
